// extracted by mini-css-extract-plugin
export default {"leftBar":"Home_leftBar__RrloG","leftSearchBar":"Home_leftSearchBar__YZ4zr"};